import { useCallback, useEffect, useId, useRef, useState } from 'react';

const TOGGLE_EVENT = 'vn-field-help:open';

function useFieldHelp() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const id = useId();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOtherOpen = (e: Event) => {
      if ((e as CustomEvent<{ id: string }>).detail.id !== id) {
        setPanelOpen((open) => (open ? false : open));
      }
    };

    document.addEventListener(TOGGLE_EVENT, handleOtherOpen);
    return () => {
      document.removeEventListener(TOGGLE_EVENT, handleOtherOpen);
    };
  }, [id]);

  const togglePanel = useCallback(() => {
    setPanelOpen((prev) => {
      const next = !prev;
      if (next) {
        document.dispatchEvent(new CustomEvent(TOGGLE_EVENT, { detail: { id } }));
      }
      return next;
    });
  }, [id]);

  const openDrawer = useCallback(() => setDrawerOpen(true), []);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  return {
    panelOpen,
    drawerOpen,
    containerRef,
    togglePanel,
    openDrawer,
    closeDrawer,
    setPanelOpen,
  };
}

export { useFieldHelp };
export default useFieldHelp;
